import { Button, useMantineTheme } from '@mantine/core'
import { hoverCssKey } from 'components/Button/_utils/getButtonComponent'
import { forwardRef } from 'react'
import type { MantineButtonProps } from '../../Button'

const Tertiary = forwardRef<HTMLButtonElement, MantineButtonProps>((props, ref) => {
  const theme = useMantineTheme()

  return (
    <Button
      ref={ref}
      css={{
        'background': theme.colors.white[0],
        'height': 40,
        'padding': '0 15px',
        'border': `2px solid ${theme.colors.midnight[0]}`,
        'fontStyle': 'normal',
        'fontWeight': 700,
        'fontSize': 14,
        'lineHeight': '19px',
        'color': theme.colors.midnight[0],
        [`&:not([disabled],[data-loading="true"]):${hoverCssKey}`]: {
          background: theme.colors.midnight[0],
          boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.25)',
          color: theme.colors.white[0],
        },
        '&[disabled],&[data-loading="true"]': {
          background: theme.colors.white[0],
          border: `2px solid ${theme.colors.grey[1]}`,
          color: theme.colors.grey[2],
          boxShadow: 'none',
          svg: {
            fill: theme.colors.grey[3],
          },
        },
        '&[data-loading="true"]::before': {
          background: 'unset',
        },
        // TODO: Blair: Not sure about this. Think about a med / large option for all buttons. Run by UX.
        ...(props.size === 'lg' || props.size === 'xl'
          ? {
              height: 40,
              fontSize: 16,
              lineHeight: '21px',
            }
          : {}),
        ...(props.size === 'sm'
          ? { height: 30, fontSize: 13, lineHeight: '14px', fontWeight: 400, padding: '0 8px' }
          : {}),
      }}
      {...props}
    />
  )
})

Tertiary.displayName = 'Tertiary'

export { Tertiary }
